<script setup>
  import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
  import Modal from "../../../../../components/ui-components/modal/Modal.vue";
  import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
  import fileService from "@/services/fileService";
  import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $fileSize } = globals;

  const resumeAttaches = ref ({
    fileName: "", // 파일명
    fileSize: "", // 파일용량
    fileDir: "", // 파일위치
  });
  const resumeFileNameSize = ref(null); // 파일명 + 용량

  const inputError = ref('');

  const baseModal = ref(null);
  const resolvePromise = ref(null);

  onMounted(()=>{
    setTimeout(()=>{
      baseModal.value.isAdminWrap = true;
    }, 500);
  })

  // 이력서 업로드
  const uploadFileCorpResume = () => {
    const input = document.createElement('input');
    input.type= 'file';
    input.click();

    input.addEventListener('change', function(event){
      // console.log(event.target.files);
      const file = event.target.files[0];

      let paramObj = {
        container: 'private',
        folder: 'ojfResume',
        file,
      }
      fileService.uploadFile(paramObj)
          .then((res) => {
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;
              // console.log(result);
              resumeAttaches.value.fileName = result.originalFilename;
              resumeAttaches.value.fileSize = result.fileSize;
              resumeAttaches.value.fileDir = result.blobUrl;
              const upFileSize = $fileSize(result.fileSize);
              resumeFileNameSize.value = result.originalFilename + '  ' + upFileSize;
            }
          }).catch( (error) =>  {
        console.log(error);
      });
    });
  }

  // 이력서 삭제
  const removeFileCorpResume = () => {  
    resumeAttaches.value.fileName = '';
    resumeAttaches.value.fileSize = '';
    resumeAttaches.value.fileDir = '';
    inputError.value = '';
    resumeFileNameSize.value = '';
  }

  // 입사지원
  const onClickApply = () => {
    let isInvalid = false;
    inputError.value = '';

    if (!resumeAttaches.value.fileName) {
      inputError.value = '이력서를 첨부해주세요.';
      isInvalid = true;
    }

    if (!isInvalid) {
      // 이력서 등록
      const result = {
        fileName: resumeAttaches.value.fileName, // string
        fileSize: resumeAttaches.value.fileSize, // string
        fileDir: resumeAttaches.value.fileDir, // string
      };
      cancel({ result });
    }
  }

  const show = () => {
    baseModal.value.open();
    return new Promise((resolve, _) => {
      resolvePromise.value = resolve;
    });
  };

  const _confirm = () => {
    baseModal.value.close();
    resolvePromise.value(true);
  };

  const cancel = (result) => {
    baseModal.value.close();
    resolvePromise.value(result || false);
  };

  defineExpose({
    show,
  })
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-title">
        <h3>'회사 이력서 양식' 입사지원</h3>
        <p>- 채용공고에서 회사의 이력서 양식을 다운로드 받아 작성하신 후 지원 바랍니다.</p>
        <p>- 첨부 파일명은 <span class="red">’기업명_이력서양식_본인이름’</span>으로 저장하여 첨부해 주세요.</p>
      </div>
      <div class="table-form" style="padding: 0 30px">
        <table class="vertical">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th class="mark">이력서 첨부</th>
            <td class="text-box">
              <div class="grid file">
                <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpResume()" />
                <KSAInput class="input icon" v-model="resumeFileNameSize" placeholder="파일 선택" disabled />
                <button class="delete" @click="removeFileCorpResume()"><i></i></button>
              </div>
              <small>최대 200MB 까지 첨부 가능</small>
              <div>
                <small style="color:#E71414;">{{ inputError }}</small>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer btn-wrap">
        <KSASecondaryButton text="취소" @click="cancel" />
        <KSAPrimaryButton text="입사지원 완료" @click="onClickApply()" />
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  width: 598px !important;
}

.modal-title p {
  margin-bottom: 0 !important;
}
.red {
  color: $red_color !important;
}

.list-top {
  p {
    margin-right: 0;
    padding-left: 2px;
    &:first-of-type {
      padding-left: 0;
    }
  }
}

.table-form {
  p {
    margin-bottom: 0 !important;
  }
  .file, .clickable {
    cursor: pointer;
    color: $blue_color !important;
  }
  .clickable {
    text-decoration: underline;
  }
}

</style>